import { Injectable } from '@angular/core';
import { ConnectionStatus, Network } from '@capacitor/network';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ConnectionService {
  constructor() {}

  public async deviceIsConnected(): Promise<boolean> {
    const status: ConnectionStatus = await Network.getStatus();
    return status.connected;
  }

  public watchConnection(): Observable<any> {
    return new Observable<any>((observer) => {
      const handler = Network.addListener('networkStatusChange', (status) => {
        observer.next(status);
      });

      // cleanup when unsubscribed
      return () => {
        handler.then((h) => h.remove());
      };
    });
  }
}
